import { request } from "@/requests/index"

export const getImgUrl = (data) => {
    return request({
        url: data,
        method: "get",
        isImg: true,
    });
};
